import { PageHeader } from "@/components/page-header";
import { QueryErrorCard } from "@/components/query-error-card";
import { TableSkeleton } from "@/components/table-skeleton";
import { Skeleton } from "@/components/ui/skeleton";
import { useAdminActivityActions, useAdminActivityAnalytics, useAdminUsers } from "@/lib/api";

import { ActivityDashboard } from "./activity-dashboard";

export function AdminActivityPage() {
  const analyticsQuery = useAdminActivityAnalytics(30);
  const usersQuery = useAdminUsers();
  const actionsQuery = useAdminActivityActions();

  const isLoading = analyticsQuery.isLoading || usersQuery.isLoading || actionsQuery.isLoading;
  const isError = analyticsQuery.isError || usersQuery.isError || actionsQuery.isError;

  const retry = () => {
    void analyticsQuery.refetch();
    void usersQuery.refetch();
    void actionsQuery.refetch();
  };

  return (
    <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6">
      <PageHeader
        eyebrow="Observability"
        title="Activity"
        description="Sign-ins and platform events over the last 30 days, with a searchable feed of everything that happened."
      />

      {isLoading ? (
        <div className="space-y-8">
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} className="h-[4.5rem] rounded-lg" />
            ))}
          </div>
          <Skeleton className="h-56 w-full rounded-lg" />
          <TableSkeleton columns={4} />
        </div>
      ) : isError || !analyticsQuery.data ? (
        <QueryErrorCard message="Could not load activity." onRetry={retry} backTo="/home" />
      ) : (
        <ActivityDashboard
          analytics={analyticsQuery.data}
          users={usersQuery.data ?? []}
          actions={actionsQuery.data ?? []}
        />
      )}
    </div>
  );
}
